<template lang="pug">
    div.configurator

        span  Enter secret

        // Tooltip
        v-tooltip.ml-1(top)
            template(
                v-slot:activator="{ on, attrs }"
                max-width="500"
            )
                v-icon(
                    color="primary"
                    v-bind="attrs" v-on="on"
                    dark
                ) info
            div.tooltip-content API secrets entered by this form are encrypted with ElGamal before storage on CleanDataSet servers. CleanDataSet cannot access your API secret and will not upload any plaintext Trading Technologies credentials.

        // Secret key
        v-text-field#secret_input(
            :label="$t('fields.tt_secret')"
            v-model="model.tt_secret"
            outlined
        )

        //Key
        v-text-field#key_input(
            :label="$t('fields.key')"
            v-model="model.key"
            outlined
        )

        div.text-right
          v-btn( v-on:click="updateSecretFromInput" large color="primary" ) Update keys
</template>

<script>
    import { ttcaller } from '~api';
    import { mapActions } from 'vuex';

    export default {
        data() {
            return {
                pubKeyHex: null,
                priKey: null,
                // eslint-disable-next-line no-undef
                sjcl: sjcl,
                model: {
                    tt_secret: '',
                    key: '',
                },
            };
        },
        async created() {
            this.priKey = window.localStorage.getItem('privateKey');

            if (!this.priKey) {
                // eslint-disable-next-line no-undef
                let keys = await this.sjcl.ecc.elGamal.generateKeys(384, 1);
                this.pubKeyHex = keys.pub.serialize().point;
                await ttcaller.uploadPublicKey(this.pubKeyHex);

                const privateKeyHex = keys.sec.serialize().exponent;
                window.localStorage.setItem('publicKey', this.pubKeyHex);
                window.localStorage.setItem('privateKey', privateKeyHex);
            } else {
                this.pubKeyHex = window.localStorage.getItem('publicKey');
                let secret = await this.getSecret();

                if (secret == null) {
                    this.showMessage(
                        'Please enter Trading Technologies credentials or log in to a device with them to sync to this one'
                    );
                } else {
                    this.updateSecret(secret);
                }

                /*
                if (secret != undefined) {
                    // Check for non-synced clients:
                    let encryptedSecrets = this.encryptAllSecrets(secret);
                    if (encryptedSecrets != {}) {
                        ttcaller.uploadEncryptedSecrets(encryptedSecrets);
                    }
                }
                */
            }
        },
        methods: {
            ...mapActions('tt', ['setSecretKey', 'getList']),
            ...mapActions('snackbar', ['showMessage']),
            async getSecret() {
                let respEncSecret =
                    await ttcaller.getEncryptedSecretByPublicKey(
                        this.pubKeyHex
                    );

                const encSecret = respEncSecret.data;

                if (encSecret == null) {
                    return null;
                }

                let priKey = new this.sjcl.ecc.elGamal.secretKey(
                    this.sjcl.ecc.curves.c384,
                    this.sjcl.bn.fromBits(
                        this.sjcl.codec.hex.toBits(
                            window.localStorage.getItem('privateKey')
                        )
                    )
                );

                return this.sjcl.decrypt(priKey, encSecret);
            },
            async encryptAllSecrets(secret) {
                let other_publics = await ttcaller.getPublicKeysWithoutSecret();

                const data = new FormData();

                other_publics.data.forEach(async (keyHex) => {
                    let pubKey = new this.sjcl.ecc.elGamal.publicKey(
                        this.sjcl.ecc.curves.c384,
                        new this.sjcl.ecc.point(
                            this.sjcl.ecc.curves.c384,
                            this.sjcl.bn.fromBits(
                                this.sjcl.codec.hex.toBits(
                                    keyHex.slice(0, keyHex.length / 2)
                                )
                            ),
                            this.sjcl.bn.fromBits(
                                this.sjcl.codec.hex.toBits(
                                    keyHex.slice(keyHex.length / 2)
                                )
                            )
                        )
                    );

                    let encryptedSecret = this.sjcl.encrypt(pubKey, secret);

                    data.append(keyHex, encryptedSecret);
                });

                return data;
            },
            async updateSecretFromInput() {
                this.updateSecret(this.model.tt_secret);
                this.showMessage('Credentials successfully added!');
            },

            async updateSecret(tt_secret) {
                window.localStorage.setItem('tt-secret', tt_secret);

                let encryptedSecrets = await this.encryptAllSecrets(tt_secret);

                this.setSecretKey();
                this.getList();

                ttcaller.uploadEncryptedSecrets(encryptedSecrets);
            },
        },
    };
</script>

<style lang="stylus" scoped>
    .configurator
        padding: 10px 0

    .tooltip-content
        max-width: 500px
</style>
